import React from "react";
import { View, Text } from "@react-pdf/renderer";
import WhereMyDocumentsMayBeFoundStyles from "../Styles";
import { NameDateRow, TwoColumnLineRow, LabelLineRow } from "./FormFields";

const InvesmentProperty = ({ primaryColor = "081e56" }) => {
  const styles = WhereMyDocumentsMayBeFoundStyles(primaryColor);

  return (
    <View style={{ ...styles.FlexStartColumn, gap: 0 }}>
      <Text style={styles.ContentSemiBold}>Investment Property</Text>
      <View style={styles.panel}>
        <View style={styles.row}>
          <View style={styles.col}>
            <LabelLineRow
              styles={styles}
              label="I own the Following Property - (other than main residence)"
              width={200}
              lines={0}
            />
            <LabelLineRow styles={styles} label="" lines={2} width={200} />
            <LabelLineRow
              styles={styles}
              label="I am the Sole / Joint Owner With"
              lines={0}
              width={200}
            />
            <LabelLineRow styles={styles} label="" lines={2} width={200} />
            <LabelLineRow styles={styles} label="Of" lines={0} width={200} />
            <LabelLineRow styles={styles} label="" lines={2} width={200} />
          </View>
          <View style={styles.col}>
            <LabelLineRow
              styles={styles}
              label="The Deeds are Located"
              width={200}
              lines={0}
            />
            <LabelLineRow styles={styles} label="" lines={2} width={200} />
            <LabelLineRow
              styles={styles}
              label="The Mortgage is with"
              lines={0}
              width={200}
            />
            <LabelLineRow styles={styles} label="" lines={2} width={200} />
            <LabelLineRow
              styles={styles}
              label="Tel No."
              lines={1}
              width={200}
            />
            <LabelLineRow
              styles={styles}
              label="Address"
              lines={0}
              width={200}
            />
            <LabelLineRow styles={styles} label="" lines={2} width={200} />
          </View>
        </View>
        <View style={{ height: 10 }} />
        <View style={styles.row}>
          <View style={styles.col}>
            <LabelLineRow
              styles={styles}
              label="I own the Following Property - (other than main residence)"
              width={200}
              lines={0}
            />
            <LabelLineRow styles={styles} label="" lines={2} width={200} />
            <LabelLineRow
              styles={styles}
              label="I am the Sole / Joint Owner With"
              lines={0}
              width={200}
            />
            <LabelLineRow styles={styles} label="" lines={2} width={200} />
            <LabelLineRow styles={styles} label="Of" lines={0} width={200} />
            <LabelLineRow styles={styles} label="" lines={2} width={200} />
          </View>
          <View style={styles.col}>
            <LabelLineRow
              styles={styles}
              label="The Deeds are Located"
              width={200}
              lines={0}
            />
            <LabelLineRow styles={styles} label="" lines={2} width={200} />
            <LabelLineRow
              styles={styles}
              label="The Mortgage is with"
              lines={0}
              width={200}
            />
            <LabelLineRow styles={styles} label="" lines={2} width={200} />
            <LabelLineRow
              styles={styles}
              label="Tel No."
              lines={1}
              width={200}
            />
            <LabelLineRow
              styles={styles}
              label="Address"
              lines={0}
              width={200}
            />
            <LabelLineRow styles={styles} label="" lines={2} width={200} />
          </View>
        </View>
      </View>
    </View>
  );
};

export default InvesmentProperty;
